<template>
        <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                    <div class="col-8">
                        <h3 class="mb-0">Neuen Standort hinzufügen</h3>
                    </div>
                </div>
            </div>
            <template>
                <form @submit.prevent="createLocationAndUser">
                    <base-alert v-if="status.type !== ''" :type="status.type">{{ status.msg }}</base-alert>
                    <h6 class="heading-small text-muted mb-4">Angaben zum Standort</h6>
                    <locationform ref="LForm"/>
                    <hr class="my-4" />
                    <!-- Address -->
                    <label class="form-control-label">
                        Einen neuen Benutzeraccount für diesen Standort anlegen?</label><br>
                    <switches v-model="createNewUser"
                              theme="bootstrap"
                              color="primary"
                              style="padding-left: 2rem;"
                              text-enabled="Ja, einen neuen Benutzer für diesen Standort anlegen."
                              text-disabled="Nein, es existiert bereits ein Benutzer"></switches><br>
                    <h6 v-if="createNewUser" class="heading-small text-muted mb-4">Service  Account</h6>
                    <userform v-if="createNewUser" shortform ref="UForm"/>
                    <button class="btn btn-icon my-4 btn-primary" :disabled="isLoading">
                        <span class="btn-inner--icon"><i v-if="isLoading" class="fas fa-circle-notch fa-spin"></i><i v-else class="ni ni-fat-add"></i></span>
                        <span class="btn-inner--text">Standort anlegen</span></button>
                </form>
            </template>
        </card>
</template>

<script>
    import Locationform from "@/views/Locations/Locationform";
    import Userform from "@/views/Users/Userform";
    import Switches from "vue-switches";

    export default {
        name: "create",
        components: {Switches, Userform, Locationform},
        data() {
            return {
                isLoading: false,
                createNewUser: true,
                status: {
                    type: '',
                    msg: ''
                }
            }
        },
        mounted() {
            Object.assign(this.$refs.LForm.location,{oasispw: null});
        },
        methods: {
            createLocationAndUser() {
                if (this.createNewUser && this.$refs.UForm.user.email === "") {
                    this.$store.dispatch('alert/error','Keine Servicebenutzer E-Mailadresse angegeben');
                } else {
                    this.isLoading = true;
                    this.createLocation()
                        .then(response => {
                            if (this.createNewUser) {
                                this.createServiceUser(response)
                                    .then(response => {
                                        this.isLoading = false;
                                        this.status =  {type: 'success', msg: 'Standort und zugehöriger Servicebenutzer (ID: '+response.id+') wurden erstellt. Das Passwort wurde per E-Mail versendet.'};
                                        this.$store.dispatch('alert/success',this.status.msg);
                                        this.$router.push('/locations');
                                    })
                                    .catch(error => {
                                        this.isLoading = false;
                                        this.status =  {type: 'danger', msg: error};
                                    })
                            } else {
                                this.isLoading = false;
                                this.status =  {type: 'success', msg: 'Standort (ID: '+response.id+') wurde erstellt. Bitte weisen Sie einem Nutzer den Standort zu.'};
                                this.$store.dispatch('alert/success',this.status.msg);
                                this.$router.push('/locations');
                            }
                        })
                        .catch(error => {
                        this.isLoading = false;
                        this.status =  {type: 'danger', msg: error};
                    })
                }
            },
            createLocation() {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    let senddata = this.$refs.LForm.location;
                    senddata.tourintervall = parseInt(senddata.tourintervall);
                    senddata.minAge = parseInt(senddata.minAge);
                    senddata.entrances = parseInt(senddata.entrances);
                    senddata.concessions = parseInt(senddata.concessions);
                    senddata.gamblingmachines = parseInt(senddata.gamblingmachines);
                    senddata.entertainmentmachines = parseInt(senddata.entertainmentmachines);
                    senddata.squaremeters = parseInt(senddata.squaremeters);
                    senddata.limitCount = parseInt(senddata.limitCount);
                    senddata.additionalLimitCount = parseInt(senddata.additionalLimitCount);
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/locations`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            },
            createServiceUser(location) {
                return new Promise((resolve, reject) => {
                    const header = this.authHeader();
                    header['Content-Type'] = 'application/json';
                    if (this.$refs.UForm.user.firstname === '') { this.$refs.UForm.user.firstname = this.$refs.LForm.location.name; }
                    let senddata = this.$refs.UForm.user;
                    senddata['customer'] = location['customer']['@id'];
                    senddata['location'] = location['@id'];
                    const requestOptions = {
                        method: 'POST',
                        headers: header,
                        body: JSON.stringify(senddata)
                    };
                    fetch(process.env.VUE_APP_API_SERVER + `/api/users`, requestOptions)
                        .then(this.handleResponse)
                        .then(response => {
                                resolve(response);
                            },
                            error => {
                                reject(error);
                            });
                });
            }
        }
    }
</script>

